import { decodeJwtToken, Cookie } from '@vezeeta/web-utils';

export const USER_ROLES = {
  OWNER: 'Owner',
  DOCTOR: 'Doctor',
  ASSISTANT: 'Assistant',
  NURSE: 'Nurse',
  ACCOUNTANT: 'Accountant',
  SINGLE_DR_APP: 'SINGLE_DR_APP',
};

export const USER_PRIVILEGES = {
  AUTHORIZED: 'AUTHORIZED',
  NOT_AUTHORIZED: 'NOT_AUTHORIZED',
  PERSONALIZED: 'PERSONALIZED',
};

const getInitComponentsPrivilege = components => {
  const componentsPrivileges = {};
  components.forEach(component => {
    componentsPrivileges[component] = {
      canReadAndWrite: USER_PRIVILEGES.AUTHORIZED,
      canReadOnly: USER_PRIVILEGES.AUTHORIZED,
    };
  });
  return componentsPrivileges;
};

export const getUserRole = () => {
  if (Cookie.get(Cookie.AUTH_TOKEN)) {
    const userToken = decodeJwtToken(Cookie.get(Cookie.AUTH_TOKEN)).payLoad;
    const userRoles = userToken.role;
    if (userRoles && userRoles.length) {
      if (userRoles.includes('Owner') && !userRoles.includes('Doctor')) return USER_ROLES.OWNER;
      if (!userRoles.includes('Owner') && userRoles.includes('Doctor')) return USER_ROLES.DOCTOR;
      if (userRoles.includes('Assistant')) return USER_ROLES.ASSISTANT;
      if (userRoles.includes('Owner') && userRoles.includes('Doctor'))
        return USER_ROLES.SINGLE_DR_APP;
      if (userRoles.some(role => role === 'Nurse')) return USER_ROLES.NURSE;
      if (userRoles.some(role => role === 'Finance')) return USER_ROLES.ACCOUNTANT;
    }
  }
};

export const getRoleBasedAccess = () => {
  const initComponentsPrivilege = getInitComponentsPrivilege([
    'appointments_view',
    'addAppointment_btn',
    'editAppointment_btn',
    'addEditVitals_btn',
    'addPresc_btn',
    'editPresc_btn',
    'displayPresc_btn',
    'printPresc_btn',
    'checkInCancelReschedule_btn',
    'openPatientProfile_btn',
    'calendar',
    'workingHours_view',
  ]);

  const userRole = getUserRole();

  switch (userRole) {
    case USER_ROLES.OWNER:
      initComponentsPrivilege.workingHours_view.canReadOnly = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.workingHours_view.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.calendar.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.editPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.appointments_view.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addAppointment_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.editAppointment_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addEditVitals_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.displayPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.printPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.checkInCancelReschedule_btn.canReadAndWrite =
        USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.openPatientProfile_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      return initComponentsPrivilege;
    case USER_ROLES.SINGLE_DR_APP:
      initComponentsPrivilege.workingHours_view.canReadOnly = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.workingHours_view.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.calendar.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.editPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.appointments_view.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addAppointment_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.editAppointment_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addEditVitals_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.displayPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.printPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.checkInCancelReschedule_btn.canReadAndWrite =
        USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.openPatientProfile_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      return initComponentsPrivilege;
    case USER_ROLES.ACCOUNTANT:
      initComponentsPrivilege.workingHours_view.canReadOnly = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.workingHours_view.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.calendar.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.editPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.appointments_view.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.addAppointment_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.editAppointment_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.addEditVitals_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.addPresc_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.displayPresc_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.printPresc_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.checkInCancelReschedule_btn.canReadAndWrite =
        USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.openPatientProfile_btn.canReadAndWrite =
        USER_PRIVILEGES.NOT_AUTHORIZED;
      return initComponentsPrivilege;
    case USER_ROLES.NURSE:
      initComponentsPrivilege.workingHours_view.canReadOnly = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.workingHours_view.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.calendar.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.editPresc_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.appointments_view.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addAppointment_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.editAppointment_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.addEditVitals_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addPresc_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.displayPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.printPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.checkInCancelReschedule_btn.canReadAndWrite =
        USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.openPatientProfile_btn.canReadAndWrite =
        USER_PRIVILEGES.NOT_AUTHORIZED;
      return initComponentsPrivilege;
    case USER_ROLES.DOCTOR:
      initComponentsPrivilege.workingHours_view.canReadOnly = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.workingHours_view.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.calendar.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.editPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.appointments_view.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addAppointment_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.editAppointment_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addEditVitals_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.displayPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.printPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.checkInCancelReschedule_btn.canReadAndWrite =
        USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.openPatientProfile_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      return initComponentsPrivilege;
    case USER_ROLES.ASSISTANT:
      initComponentsPrivilege.workingHours_view.canReadOnly = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.workingHours_view.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.calendar.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.editPresc_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.appointments_view.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addAppointment_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.editAppointment_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.addEditVitals_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.addPresc_btn.canReadAndWrite = USER_PRIVILEGES.NOT_AUTHORIZED;
      initComponentsPrivilege.displayPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.printPresc_btn.canReadAndWrite = USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.checkInCancelReschedule_btn.canReadAndWrite =
        USER_PRIVILEGES.AUTHORIZED;
      initComponentsPrivilege.openPatientProfile_btn.canReadAndWrite =
        USER_PRIVILEGES.NOT_AUTHORIZED;
      return initComponentsPrivilege;

    default:
      break;
  }

  return initComponentsPrivilege;
};
